import { render, staticRenderFns } from "./TransfertCreditsModal.vue?vue&type=template&id=10fb5e3d&scoped=true&"
import script from "./TransfertCreditsModal.vue?vue&type=script&lang=js&"
export * from "./TransfertCreditsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fb5e3d",
  null
  
)

export default component.exports